import { render, staticRenderFns } from "./CardInvite.vue?vue&type=template&id=71b975a6&"
import script from "./CardInvite.vue?vue&type=script&lang=js&"
export * from "./CardInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports